<script setup lang="ts">
import type { ComponentPromoGiftProps } from "./ComponentPromoGift.props"
const props = defineProps<ComponentPromoGiftProps>()
const fallbackImage = "/images/avene.png" //temporary fallback image, to be updated
const imageUrl = props.image?.image?.url || fallbackImage
const ctaPath: string | undefined =
  typeof props.cta?.path === "string" ? props.cta.path : undefined
</script>

<template>
  <div
    v-if="props.title || props.description"
    class="
      bg-orange-10
      relative
      mb-3
      min-h-[200px]
      overflow-hidden
      bg-[url('/images/banner_omaggio.jpg')]
      bg-[length:auto_150px]
      bg-left-bottom bg-no-repeat
      p-6
    "
  >
    <img
      :src="imageUrl"
      class="absolute -right-5 bottom-0 max-h-[200px] object-contain md:right-0"
    />
    <div class="relative z-10 flex w-2/3 min-w-[200px] flex-col gap-2">
      <UtilsMarkdown
        class="hyppo-bold markdown__strong-green-main-first-child"
        :content="props.title"
      />
      <UtilsMarkdown class="beaver" :content="props.description" />
      <AppLink
        v-if="props.cta?.text && ctaPath"
        :to="ctaPath"
        class="
          bg-transparent
          text-green-600
          beaver-medium
          flex
          items-center
          gap-2
          underline
        "
      >
        <span class="text-green-main">{{ props.cta.text }}</span>
        <img
          src="/icons/green-main/ArrowRight.svg"
          alt="arrow icon"
          class="h-5 w-5 -rotate-45"
        />
      </AppLink>
    </div>
  </div>
</template>
